export default {"src":"/_next/static/media/CareQualityLogo.7bfcea56.svg","height":80,"width":169,"blurWidth":0,"blurHeight":0};